import React, { useState } from "react";
import { Card, Form, Input, Button, Alert, Typography } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { apiLogin } from "../api/auth";
import ROUTE_PATHS from "../routes/routePaths";

const { Title } = Typography;

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  async function onFinish(values) {
    setErr("");
    setLoading(true);

    try {
      await apiLogin(values.username, values.password);

      const redirectTo =
        location.state?.from || ROUTE_PATHS.TRANSACTION_SCHEDULE;

      navigate(redirectTo, { replace: true });
    } catch (e) {
      setErr(e?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <Card className="w-full max-w-md">
        <div className="px-4 py-6">
          <Title level={3} className="!mb-6 text-center">
            SFG system login
          </Title>

          {err && (
            <Alert type="error" showIcon message={err} className="mb-4" />
          )}

          <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
            <Form.Item
              name="username"
              label="Username"
              rules={[{ required: true }]}
            >
              <Input autoComplete="username" />
            </Form.Item>

            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true }]}
            >
              <Input.Password autoComplete="current-password" />
            </Form.Item>

            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
              className="!h-11"
            >
              Sign in
            </Button>
          </Form>
        </div>
      </Card>
    </div>
  );
}